// BOXEB2B — Les 5 premiers emails outbound (rédigés pour attraper le 1er client)
// Copie-colle directement. Personnalise juste {{prenom}} et {{societe}}.

export const FIRST_CLIENT_EMAILS = [
    {
        id: 1,
        target: "SDR freelance / consultant B2B parisien",
        find_in_boxeb2b: "AI Prospecting → 'SDR freelance Paris' OU segment title_keywords=['SDR','commercial','sales']",
        expected_targets: 25,
        subject: "Ton stack de prospection en 2026, {{prenom}} ?",
        body: `Salut {{prenom}},

Question rapide : quand tu prospectes pour tes clients aujourd'hui, tu utilises quoi comme outil ? Apollo à 400€/mois, Cognism à 15k€/an, ou tu bricoles avec LinkedIn + Google ?

Je viens de lancer BOXEB2B (boxe-b2b.com) : 50 crédits gratuits, aucune carte, tu importes 200 leads INSEE réels en 30 sec et l'IA génère tes séquences.

Je cherche 3 SDR freelance pour tester en early access — feedback contre 500 crédits offerts. Ça t'intéresse ?

Franck

--
BOXEB2B — Sales intelligence pour PME. Se désinscrire : reply "STOP"`,
        expected_reply_rate: "8-12%"
    },
    {
        id: 2,
        target: "Founder solo B2B (agence lead-gen, SaaS early)",
        find_in_boxeb2b: "AI Prospecting → 'founder B2B agency startup Paris'",
        expected_targets: 20,
        subject: "Vu ton post LinkedIn sur la prospection",
        body: `Bonjour {{prenom}},

Vu ton post récent sur LinkedIn concernant la prospection B2B. Je me demandais : c'est quoi ta principale galère aujourd'hui pour trouver des leads qualifiés ?

Je te demande parce que j'ai construit BOXEB2B pour résoudre exactement ce problème : import INSEE + enrichissement IA + envoi séquences, en pay-as-you-go (pas d'engagement 12 mois comme Cognism).

Free trial 50 crédits, sans carte. Si tu penses que ça peut t'aider, on peut faire un call 15 min pour que je te montre.

Franck
boxe-b2b.com

--
Se désinscrire : reply "STOP"`,
        expected_reply_rate: "10-15%"
    },
    {
        id: 3,
        target: "PME BTP Guyane (dirigeant)",
        find_in_boxeb2b: "Segments → country=Guyane, industry=BTP, size=11-50",
        expected_targets: 30,
        subject: "Bonjour {{prenom}}, question sur {{societe}}",
        body: `Bonjour {{prenom}},

Je m'appelle Franck, je viens de lancer BOXEB2B — une plateforme française pour aider les PME comme {{societe}} à trouver de nouveaux marchés en Guyane.

Question directe : comment vous trouvez actuellement les nouveaux promoteurs / donneurs d'ordres qui s'installent en Guyane ? Bouche à oreille ? Journal ? Pages Jaunes ?

Notre outil scanne l'INSEE en temps réel et vous alerte des nouvelles boîtes 24h après leur immatriculation en 973. 50 crédits offerts pour tester.

15 min pour vous montrer si c'est utile pour vous ?

Franck
boxe-b2b.com — 0594 XX XX XX

--
Se désinscrire : reply "STOP"`,
        expected_reply_rate: "6-10%"
    },
    {
        id: 4,
        target: "Growth marketer / opérateur digital",
        find_in_boxeb2b: "AI Prospecting → 'growth marketer digital B2B'",
        expected_targets: 25,
        subject: "5 min sur ton budget outbound ?",
        body: `Salut {{prenom}},

J'ai vu que tu bosses growth chez {{societe}} — question rapide, tu as un budget outbound alloué ou tout est inbound / SEO chez toi ?

Je te demande parce que je viens de lancer BOXEB2B : au lieu de payer 400€/mois pour Apollo, tu ne paies que ce que tu utilises (crédits à 0.05€ pièce). C'est adapté aux équipes qui font 100-500 outreach/mois.

Free trial 50 crédits sans carte. Si c'est un sujet pour toi cette année, je te fais 15 min ?

Franck
boxe-b2b.com

--
Se désinscrire : reply "STOP"`,
        expected_reply_rate: "7-11%"
    },
    {
        id: 5,
        target: "Restaurant / bar Cayenne / Kourou (patron)",
        find_in_boxeb2b: "Segments → country=Guyane, industry=Restaurants",
        expected_targets: 25,
        subject: "Vos jours creux, {{prenom}}",
        body: `Bonjour {{prenom}},

Petit test rapide : comment vous remplissez le mercredi soir chez {{societe}} ?

J'imagine que le week-end est bien mais que les jours en semaine sont plus calmes. C'est classique pour les restaurateurs.

J'ai lancé BOXEB2B : un outil qui trouve les entreprises de {{city}} avec 20+ salariés (celles qui organisent leurs pots, séminaires, repas d'équipe). 50 crédits offerts pour tester.

Ça vous parle ? 5 min de call demain ou après-demain ?

Franck
boxe-b2b.com

--
Se désinscrire : reply "STOP"`,
        expected_reply_rate: "5-9%"
    },
];

export const OUTBOUND_STRATEGY = {
    "warmup_weeks": 4,
    "max_per_day_week1": 5,
    "max_per_day_week2": 10,
    "max_per_day_week3": 15,
    "max_per_day_week4": 20,
    "target_reply_rate": "6-12%",
    "target_first_client_days": 30,
    "notes": [
        "Envoie tes 5 premiers emails à la main avant l'autopilote — tu apprends le ton",
        "Configure SPF/DKIM/DMARC sur boxe-b2b.com avant tout envoi",
        "Utilise Resend (100 emails/jour gratuits) pour l'infra d'envoi",
        "Suis chaque bounce dans /app/analyze — pause auto si >5% bounces",
    ],
};
